module.exports = __webpack_public_path__ + "static/media/icons-navigation-down.2c0ecc28.svg";